import "./base.js";
import "./header/main_menu.js";
import "./header/main_menu_expander.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

const __HeaderPrior = AppointmentBooking.Wizard.Views.Header;
AppointmentBooking.Wizard.Views.Header = class Header extends AppointmentBooking.Wizard.Views.Base {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.mainMenu = new AppointmentBooking.Wizard.Views.Header.MainMenu({
      model: this.model,
      condition: () => this.model.currentStep() !== "Confirmation",
    });

    return (this.mainMenuExpander = new AppointmentBooking.Wizard.Views.Header.MainMenuExpander({
      model: this.model,
      condition: () => this.model.currentStep() !== "Confirmation",
    }));
  }

  // RENDERING

  render() {
    super.render(...arguments);
    this.replaceContents(".main-menu-expander-container", this.mainMenuExpander.render().el);
    this.replaceContents(".main-menu-container", this.mainMenu.render().el);

    return this;
  }
};
AppointmentBooking.Wizard.Views.Header.prototype.tagName = "div";
AppointmentBooking.Wizard.Views.Header.prototype.template = "header";
AppointmentBooking.Wizard.Views.Header.prototype.className = "appointment-booking-wizard-header";
if (__HeaderPrior) {
  Object.assign(AppointmentBooking.Wizard.Views.Header, __HeaderPrior);
}
